import EcoSpace from 'eco-design/base/eco-space';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import styles from './index.module.scss';
import { useEffect, useState } from 'react';
import gtm from '@/utils/gtm';
import Close from './icon/icon';
import { useLang } from '@/i18n';
import EfSection from '@elem/ui/ef-section';

const JF: React.FC = () => {
    const { t } = useLang('delta3series');
    const [active, setActive] = useState(0);
    const arr = [
        {
            title: t('JF_bar1'),
            text: t.rich('JF_bar1_text', {
                blue: (text: string) => <span className="blue">{text}</span>,
            }),
        },
        {
            title: t('JF_bar2'),
            text: t.rich('JF_bar2_text', {
                blue: (text: string) => <span className="blue">{text}</span>,
            }),
        },
        {
            title: t('JF_bar3'),
            text: t.rich('JF_bar3_text', {
                blue: (text: string) => <span className="blue">{text}</span>,
            }),
        },
        {
            title: t('JF_bar4'),
            text: t.rich('JF_bar4_text', {
                blue: (text: string) => <span className="blue">{text}</span>,
            }),
        },
    ];

    const handleClickBar = (e: any, k: number) => {
        e.stopPropagation();
        setActive(k === active ? -1 : k);
        const gtmValue = localStorage.getItem(`--delta-3-series-portable-power-station-${k + 1}`) || '';

        //第一次点击展开
        if (!gtmValue && k !== active) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'product_details',
                tab: t('F_title'),
                button_name: t(`JF_bar${k + 1}`),
            });
            localStorage.setItem(`--delta-3-series-portable-power-station-${k + 1}`, `${k + 1}`);
        }
    };
    return (
        <div className={styles.comp} id="d3-F">
            <EcoSpace />
            <EfSection label={t('F_label')} title={t('F_title')} />
            <EcoSpaceSmall />
            <div className="img-box">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1740714273924/%E9%AB%98%E5%87%BA%E5%8A%9B%20(1).jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1740714259123/Mask%20group.jpg"
                />
                <ul className="bars">
                    {arr?.map((item: any, k: number) => (
                        <li className={`bar-box ${active === k ? 'active' : ''} box${k + 1}`} key={item.title}>
                            <div className="bar-base" onClick={(e: any) => handleClickBar(e, k)}>
                                <div className="plus-icon">
                                    <Close />
                                </div>
                            </div>
                            <div className="bar-toggle-box ">
                                {item?.title && <p className="toggle-title">{item.title}</p>}
                                {item?.text && <p className="toggle-text">{item.text}</p>}
                            </div>
                            <div className="bar-toggle-box title">{item?.title && <p className="toggle-title">{item.title}</p>}</div>
                        </li>
                    ))}
                </ul>
                <EcoImg
                    className="logo"
                    pc="https://websiteoss.ecoflow.com/upload/image/1740738280401/Group%201000008512.png"
                    pad="https://websiteoss.ecoflow.com/upload/image/1740738280401/Group%201000008512.png"
                    h5="https://websiteoss.ecoflow.com/upload/image/1740738713483/Group%201000008485%20(1).png"
                ></EcoImg>
                {/* TODO: 交互参考 - https://www.ecoflow.com/us/on-the-road-power-solution */}
            </div>
        </div>
    );
};

export default JF;
